"use client";

import { defaultLocale, type Locale } from "@/lib/i18n";
import AgentUseCasePage from "./AgentUseCasePage";
import { contractReview } from "@/content/agent-use-cases/contract-review";

export default function ContractReviewUseCase({
  locale = defaultLocale,
}: {
  locale?: Locale;
}) {
  return <AgentUseCasePage useCase={contractReview} locale={locale} />;
}
